import React from 'react';
import ResponsiveImage from '../../ResponsiveImage';
import RichText from '../RichText';
import { StyledWrapper } from './EmbbedEntryTextImageStyles';

/**
 * Render inline link in rich text
 *
 * @param {String} copy
 *
 * @returns {React.ReactElement}
 */
function EmbbedEntryTextImage(fields) {
  const { copyText, image, imgPositionDesktop } = fields;

  return (
    <StyledWrapper $imgPositionDesktop={imgPositionDesktop}>
      <ResponsiveImage {...image} gatsbyImageOptions={{ loading: 'eager' }} />
      <div>
        <RichText document={copyText} />
      </div>
    </StyledWrapper>
  );
}

export default EmbbedEntryTextImage;
